// hnb-frontend/src/api/providers.ts

import { apiFetch } from './client';
import type { ApiListResponse } from './types';

export type Provider = {
  id: string;
  businessName: string;
  contactName?: string | null;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  postcode?: string | null;
  status?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

type ProviderApiRecord = {
  id: string;
  businessName?: string | null;
  business_name?: string | null;
  name?: string | null;
  contactName?: string | null;
  contact_name?: string | null;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  postcode?: string | null;
  status?: string | null;
  verification_status?: string | null;
  createdAt?: string | null;
  created_at?: string | null;
  updatedAt?: string | null;
  updated_at?: string | null;
};

function mapProvider(record: ProviderApiRecord): Provider {
  return {
    id: record.id,
    businessName:
      record.businessName ??
      record.business_name ??
      record.name ??
      'Unnamed provider',
    contactName: record.contactName ?? record.contact_name ?? null,
    email: record.email ?? null,
    phone: record.phone ?? null,
    city: record.city ?? null,
    postcode: record.postcode ?? null,
    status: record.status ?? record.verification_status ?? null,
    createdAt: record.createdAt ?? record.created_at ?? undefined,
    updatedAt: record.updatedAt ?? record.updated_at ?? undefined,
  };
}

export async function getProviders(): Promise<ApiListResponse<Provider>> {
  // This hits `${env.apiBaseUrl}/providers`, e.g. http://localhost:4000/api/providers
  const response =
    await apiFetch<ApiListResponse<ProviderApiRecord>>('/providers');

  return {
    ...response,
    data: response.data.map(mapProvider),
  };
}